import Geocode from 'react-geocode'
import { ACCEPTED_GOOGLE_RESPONSE_TYPES, Coordinates, CoordinatesError, CoordinatesRequestData } from './types'

/**
 * fetch coordinates for given address data only if usage of google services has been accepted.
 * @param customerFormData address data that the corresponding coordinates are requested for
 * @param googleAgreed boolean whether or not the user agreed to use google maps, because google API is used for the request
 * @returns Promise with latitude and longitude and error flag
 */
export const fetchCoordinates = (customerFormData: CoordinatesRequestData, googleAgreed?: boolean): Promise<Coordinates> => {
  if (!googleAgreed) return Promise.reject(CoordinatesError.SERVICE_DENIED)

  Geocode.setApiKey(process.env.REACT_APP_MAPS_TOKEN ?? '')
  Geocode.setRegion(customerFormData.countryCode)
  const address = `${customerFormData.streetName} ${customerFormData.streetNumber}`

  return Geocode.fromAddress(`${address} ${customerFormData.city} ${customerFormData.zip}`).then(response => {
    const isAcceptedResponseType = ACCEPTED_GOOGLE_RESPONSE_TYPES.includes(response.results[0].types[0])

    if (response && response.status === 'OK' && isAcceptedResponseType) {
      const { lat, lng } = response.results[0].geometry.location
      return { latitude: lat.toFixed(10), longitude: lng.toFixed(10) }
    } else {
      return Promise.reject(CoordinatesError.INVALID_RESPONSE)
    }
  })
}
